import { HELIX_CRQS_ACTIONS } from '../actions/helixCrqsActions';

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const isSameData = (prev, next) =>
	JSON.stringify(prev) === JSON.stringify(next);

const toArray = (val) => (Array.isArray(val) ? val : []);

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		// Creations
		crqsToCreate:               false,
		crqsOnQueueWithError:       false,
		crqsToCreateAction:         false,
		crqsOnQueueWithErrorAction: false,
		// Changes
		crqsToClose:          false,
		crqsToCancel:         false,
		crqsToApprove:        false,
		crqsToChangeAction:   false,
		// Other
		crqsWithConflicts:          false,
		crqsToAddActivity:          false,
		crqsWithConflictsAction:    false,
		crqsToAddActivityAction:    false,
		// Upload
		botSummary:                      false,
		downloadCreationsTemplate:       false,
		downloadChangesTemplate:         false,
		downloadAddActivityTemplate:     false,
		// Statistics
		statistics:                false,
		// Creations: Export
		exportCrqsCreations:       false,
		// Changes: Export
		exportCrqsChanges:         false,
		// Other: Export
		exportCrqsOther:           false,
		// Statistics: Export
		exportCrqsStatistics:      false,
	},
	// Creations
	crqsToCreate:         [],
	crqsOnQueueWithError: [],
	// Changes
	crqsToClose:          [],
	crqsToCancel:         [],
	crqsToApprove:        [],
	// Other
	crqsWithConflicts:    [],
	crqsToAddActivity:    [],
	// Upload
	botSummary:           null,
	// Statistics
	statistics:     null,
	error: null,
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const HelixCrqsReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Creations: Get CRQs to Create ─────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToCreate: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsToCreate, next))
							return { ...state, loading: { ...state.loading, crqsToCreate: false } };
						return { ...state, loading: { ...state.loading, crqsToCreate: false }, crqsToCreate: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToCreate: false }, error: action.error };

						// ── Creations: Get CRQs on Queue with Error ────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithError: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsOnQueueWithError, next))
							return { ...state, loading: { ...state.loading, crqsOnQueueWithError: false } };
						return { ...state, loading: { ...state.loading, crqsOnQueueWithError: false }, crqsOnQueueWithError: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithError: false }, error: action.error };

						// ── Creations: CRQs to Create Action ──────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToCreateAction: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_SUCCESS:
						return { ...state, loading: { ...state.loading, crqsToCreateAction: false } };
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToCreateAction: false }, error: action.error };

						// ── Creations: CRQs on Queue with Error Action ─────────────────────────
					case HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithErrorAction: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithErrorAction: false } };
					case HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithErrorAction: false }, error: action.error };

						// ── Changes: Get CRQs to Close ─────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CLOSE_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToClose: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CLOSE_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsToClose, next))
							return { ...state, loading: { ...state.loading, crqsToClose: false } };
						return { ...state, loading: { ...state.loading, crqsToClose: false }, crqsToClose: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CLOSE_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToClose: false }, error: action.error };

						// ── Changes: Get CRQs to Cancel ───────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CANCEL_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToCancel: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CANCEL_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsToCancel, next))
							return { ...state, loading: { ...state.loading, crqsToCancel: false } };
						return { ...state, loading: { ...state.loading, crqsToCancel: false }, crqsToCancel: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CANCEL_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToCancel: false }, error: action.error };

						// ── Changes: Get CRQs to Approve ──────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_APPROVE_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToApprove: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_APPROVE_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsToApprove, next))
							return { ...state, loading: { ...state.loading, crqsToApprove: false } };
						return { ...state, loading: { ...state.loading, crqsToApprove: false }, crqsToApprove: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_APPROVE_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToApprove: false }, error: action.error };

						// ── Changes: Action ────────────────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_CHANGE_ACTION_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToChangeAction: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_CHANGE_ACTION_SUCCESS:
						return { ...state, loading: { ...state.loading, crqsToChangeAction: false } };
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_CHANGE_ACTION_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToChangeAction: false }, error: action.error };

						// ── Other: Get CRQs with Conflicts ────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_WITH_CONFLICTS_REQUEST:
						return { ...state, loading: { ...state.loading, crqsWithConflicts: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_WITH_CONFLICTS_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsWithConflicts, next))
							return { ...state, loading: { ...state.loading, crqsWithConflicts: false } };
						return { ...state, loading: { ...state.loading, crqsWithConflicts: false }, crqsWithConflicts: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_WITH_CONFLICTS_FAILURE:
						return { ...state, loading: { ...state.loading, crqsWithConflicts: false }, error: action.error };

						// ── Other: Get CRQs to Add Activity ───────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_ADD_ACTIVITY_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToAddActivity: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_ADD_ACTIVITY_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.crqsToAddActivity, next))
							return { ...state, loading: { ...state.loading, crqsToAddActivity: false } };
						return { ...state, loading: { ...state.loading, crqsToAddActivity: false }, crqsToAddActivity: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_ADD_ACTIVITY_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToAddActivity: false }, error: action.error };

						// ── Other: CRQs with Conflicts Action ─────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_CRQS_WITH_CONFLICTS_ACTION_REQUEST:
						return { ...state, loading: { ...state.loading, crqsWithConflictsAction: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_CRQS_WITH_CONFLICTS_ACTION_SUCCESS:
						return { ...state, loading: { ...state.loading, crqsWithConflictsAction: false } };
					case HELIX_CRQS_ACTIONS.HC_CRQS_WITH_CONFLICTS_ACTION_FAILURE:
						return { ...state, loading: { ...state.loading, crqsWithConflictsAction: false }, error: action.error };

						// ── Other: CRQs to Add Activity Action ────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_ADD_ACTIVITY_ACTION_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToAddActivityAction: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_ADD_ACTIVITY_ACTION_SUCCESS:
						return { ...state, loading: { ...state.loading, crqsToAddActivityAction: false } };
					case HELIX_CRQS_ACTIONS.HC_CRQS_TO_ADD_ACTIVITY_ACTION_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToAddActivityAction: false }, error: action.error };

						// ── Upload: Get Bot Summary ────────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_BOT_SUMMARY_REQUEST:
						return { ...state, loading: { ...state.loading, botSummary: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_BOT_SUMMARY_SUCCESS: {
						const next = action.payload ?? null;
						if (isSameData(state.botSummary, next))
							return { ...state, loading: { ...state.loading, botSummary: false } };
						return { ...state, loading: { ...state.loading, botSummary: false }, botSummary: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_BOT_SUMMARY_FAILURE:
						return { ...state, loading: { ...state.loading, botSummary: false }, error: action.error };

						// ── Upload: Download Creations Template ───────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_TEMPLATE_REQUEST:
						return { ...state, loading: { ...state.loading, downloadCreationsTemplate: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_TEMPLATE_SUCCESS:
						return { ...state, loading: { ...state.loading, downloadCreationsTemplate: false } };
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_TEMPLATE_FAILURE:
						return { ...state, loading: { ...state.loading, downloadCreationsTemplate: false }, error: action.error };

						// ── Upload: Download Changes Template ─────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_CHANGES_TEMPLATE_REQUEST:
						return { ...state, loading: { ...state.loading, downloadChangesTemplate: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_CHANGES_TEMPLATE_SUCCESS:
						return { ...state, loading: { ...state.loading, downloadChangesTemplate: false } };
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_CHANGES_TEMPLATE_FAILURE:
						return { ...state, loading: { ...state.loading, downloadChangesTemplate: false }, error: action.error };

						// ── Upload: Download Add Activity Template ─────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_REQUEST:
						return { ...state, loading: { ...state.loading, downloadAddActivityTemplate: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_SUCCESS:
						return { ...state, loading: { ...state.loading, downloadAddActivityTemplate: false } };
					case HELIX_CRQS_ACTIONS.HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_FAILURE:
						return { ...state, loading: { ...state.loading, downloadAddActivityTemplate: false }, error: action.error };

						// ── Statistics: Get Statistics ────────────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_STATISTICS_REQUEST:
						return { ...state, loading: { ...state.loading, statistics: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_GET_STATISTICS_SUCCESS: {
						const next = action.payload ?? null;
						if (isSameData(state.statistics, next))
							return { ...state, loading: { ...state.loading, statistics: false } };
						return { ...state, loading: { ...state.loading, statistics: false }, statistics: next, error: null };
					}
					case HELIX_CRQS_ACTIONS.HC_GET_STATISTICS_FAILURE:
						return { ...state, loading: { ...state.loading, statistics: false }, error: action.error };

						// ── Creations: Export CRQs to Create ──────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CREATIONS_REQUEST:
						return { ...state, loading: { ...state.loading, exportCrqsCreations: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CREATIONS_SUCCESS:
						return { ...state, loading: { ...state.loading, exportCrqsCreations: false } };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CREATIONS_FAILURE:
						return { ...state, loading: { ...state.loading, exportCrqsCreations: false }, error: action.error };

						// ── Changes: Export CRQs Changes ──────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CHANGES_REQUEST:
						return { ...state, loading: { ...state.loading, exportCrqsChanges: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CHANGES_SUCCESS:
						return { ...state, loading: { ...state.loading, exportCrqsChanges: false } };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CHANGES_FAILURE:
						return { ...state, loading: { ...state.loading, exportCrqsChanges: false }, error: action.error };

						// ── Other: Export CRQs Other ──────────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_OTHER_REQUEST:
						return { ...state, loading: { ...state.loading, exportCrqsOther: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_OTHER_SUCCESS:
						return { ...state, loading: { ...state.loading, exportCrqsOther: false } };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_OTHER_FAILURE:
						return { ...state, loading: { ...state.loading, exportCrqsOther: false }, error: action.error };

						// ── Statistics: Export ────────────────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_STATISTICS_REQUEST:
						return { ...state, loading: { ...state.loading, exportCrqsStatistics: true }, error: null };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_STATISTICS_SUCCESS:
						return { ...state, loading: { ...state.loading, exportCrqsStatistics: false } };
					case HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_STATISTICS_FAILURE:
						return { ...state, loading: { ...state.loading, exportCrqsStatistics: false }, error: action.error };

					default:
						return state;
	}
};

export default HelixCrqsReducer;